import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';
import { ApiResource, PROGRESSION_STATE_ENDPOINTS, ProgressionState, ProgressionStateKey } from '@nxtpeople/nxt-styles';
import { NavigationGuard } from 'vue-router';

const FOLLOW_UP_OVERVIEW_GUARD: NavigationGuard = async (to, from, next) => {
   const hasProgressionStateQuery = to.query.progression_state_ids !== undefined;
   const hasShowMyCaseFilesQuery = to.query.show_my_case_files !== undefined;

   if (hasProgressionStateQuery && hasShowMyCaseFilesQuery) return next();

   const newQuery = { ...to.query };

   if (!hasProgressionStateQuery) {
      const { data } = await http.get<ApiResource<Array<ProgressionState>>>(PROGRESSION_STATE_ENDPOINTS.GET_ALL(), {
         ...cacheFirstConfig,
      });
      const progressionStates = Array.isArray(data?.data) ? data.data : [];
      const defaultProgressionStateIds = progressionStates
         .filter((state) => [ProgressionStateKey.Open, ProgressionStateKey.InProgress].includes(state.key))
         .map((state) => state.id.toString());
      newQuery.progression_state_ids = defaultProgressionStateIds;
   }

   if (!hasShowMyCaseFilesQuery) {
      newQuery.show_my_case_files = '1';
   }

   return next({ ...to, query: newQuery });
};

export default FOLLOW_UP_OVERVIEW_GUARD;
